import React from 'react';
import '../CSS/AbsenceManagement.css';
import absenceHeroImg from '../Images/services/Absence Management Services/services-absence-management-services.png';
import absenceHeroImgMob from '../Images/Mobile Images/services/Absence Management Services/service-absence-management-banner-image.png';
import absenceDividerImg from '../Images/services/Absence Management Services/absence-management-services-divider-image.png';
import absenceDividerImgMob from '../Images/Mobile Images/services/Absence Management Services/absence-management-services-divider-image-mobile.png';

import peopleIcon from '../Images/services/people-icon.svg';
import processIcon from '../Images/services/process-icon.svg';
import resultsIcon from '../Images/services/results-icon.svg';
import { Link } from 'react-router-dom';

const AbsenceManagement: React.FC = () => {
  return (
    <>
      <div className="absence-hero">
        <div
          className="absence-hero-img"
          style={{ '--hero-bg': `url(${absenceHeroImg})`, '--hero-bg-mob': `url(${absenceHeroImgMob})`, backgroundImage: `url(${absenceHeroImg})` } as React.CSSProperties}
        >
          <div className="absence-hero-overlay" />
          <div className="absence-hero-content">
            <div className="absence-hero-title">Absence Management Services</div>
            <div className="absence-hero-main">Address Nursing Shortages with Confidence</div>
            <div className="absence-hero-desc">
              Sustainably recruit and retain high-quality nurses committed to patient care and community impact.
            </div>
          </div>
        </div>
      </div>
      {/* Solutions for Absence Management Section */}
      <div className="solutions-for-absence-management">
        <div className="sfam-left">
          <div className="sfam-heading">Scalable, Quality-Driven <br />Solutions for your Absence Management</div>
          <Link to="/contact-us" className="sfam-contact-btn">Contact Us</Link>
        </div>
        <div className="sfam-right">
          <div className="sfam-card-grid">
            <div className="sfam-card">
              <div className="sfam-card-title">Document Management</div>
              <div className="sfam-card-desc">Sorting, entering, and uploading documents and information to update client profile, claim, and leaves.</div>
            </div>
            <div className="sfam-card">
              <div className="sfam-card-title">Americans with Disabilities Act</div>
              <div className="sfam-card-desc">Processing of claims to set up accommodation leaves disability.</div>
            </div>
            <div className="sfam-card">
              <div className="sfam-card-title">Eligibility Assistance</div>
              <div className="sfam-card-desc">Evaluating leave requests and eligibility for FMLA and state leaves. Processing & updating claim information from medical certificates received through fax & other sources.</div>
            </div>
            <div className="sfam-card">
              <div className="sfam-card-title">Nurse Case Management</div>
              <div className="sfam-card-desc">Assessment of medical records to determine a claimant's functionality to go back to work for short-term & long-term disability requests. Provide recommendations to manage the claimant's condition/situation.</div>
            </div>
            <div className="sfam-card">
              <div className="sfam-card-title">Disability Claim Payment</div>
              <div className="sfam-card-desc">Assisting in disability claims focusing on benefit payments given to disabled claimants.</div>
            </div>
            <div className="sfam-card">
              <div className="sfam-card-title">Nurse Disability Review</div>
              <div className="sfam-card-desc">Comprehensive assessment of medical records to identify claimant's functionality and return to work.</div>
            </div>
            <div className="sfam-card">
              <div className="sfam-card-title">Provider Verification</div>
              <div className="sfam-card-desc">Updating client information from medical certificates via phone.</div>
            </div>
            <div className="sfam-card">
              <div className="sfam-card-title">Performance Guarantee Audits</div>
              <div className="sfam-card-desc">Auditing of onshore processes.</div>
            </div>
          </div>
        </div>
      </div>
      {/* Absence Management Statistic Section */}
      <div className="absence_management_statistic">
        <div className="absence_management_statistic_heading">
          Quality Isn't Just a Metric—It's a Mission. Medwell360 Delivers Nothing Less.
        </div>
        <div className="absence_management_statistic_row">
          <div className="absence_management_statistic_item">
            <div className="absence_management_statistic_value">99%</div>
            <div className="absence_management_statistic_label">Quality Accuracy</div>
          </div>
          <div className="absence_management_statistic_item">
            <div className="absence_management_statistic_value">&lt;24 hr</div>
            <div className="absence_management_statistic_label">Completion & Processing Time</div>
          </div>
          <div className="absence_management_statistic_item">
            <div className="absence_management_statistic_value">20+</div>
            <div className="absence_management_statistic_label">Health Service Providers and Managed Care Organizations</div>
          </div>
        </div>
      </div>
      {/* Healthcare Challenges Facts Section */}
      <div className="healthcare_challenges_facts">
        <div className="healthcare_challenges_facts_heading">
          AI Services for Patient Care
        </div>
        <div className="healthcare_challenges_facts_row">
          <div className="healthcare_challenges_facts_card">
            <div className="healthcare_challenges_facts_card_title">Rising Employee Absenteeism</div>
            <div className="healthcare_challenges_facts_card_desc">Organizations face escalating labor costs as they compensate for lost productivity stemming from missed work hours due to employee absences.</div>
          </div>
          <div className="healthcare_challenges_facts_card">
            <div className="healthcare_challenges_facts_card_title">Surge in Workplace Disruption</div>
            <div className="healthcare_challenges_facts_card_desc">Frequent disruptions—often triggered by absenteeism or behavioral issues—hinder overall workflow and increase the burden on staffing and resource management.</div>
          </div>
          <div className="healthcare_challenges_facts_card">
            <div className="healthcare_challenges_facts_card_title">Decline in Workforce Productivity</div>
            <div className="healthcare_challenges_facts_card_desc">When employees underperform or are misaligned with their roles, it results in suboptimal use of skills and capabilities—driving up operational and resourcing expenses.</div>
          </div>
        </div>
      </div>
      {/* Absence Management Divider Image */}
      <div className="absence_management_divider">
        <picture>
          <source media="(max-width: 1100px)" srcSet={absenceDividerImgMob} />
          <img src={absenceDividerImg} alt="Absence Management Divider" className="absence_management_divider_img" />
        </picture>
      </div>
      {/* Absence Clinical Outcomes Section */}
      <div className="absence_clinical_outcomes">
        <div className="absence_clinical_outcomes_heading">
          Partner with Us to Deliver Scalable, High-Quality Clinical Outcomes
        </div>
        <div className="absence_clinical_outcomes_row">
          <div className="absence_clinical_outcomes_card">
            <img src={peopleIcon} alt="People Icon" className="absence_clinical_outcomes_icon" />
            <div className="absence_clinical_outcomes_card_title">People</div>
            <ul className="absence_clinical_outcomes_list">
              <li><b>Certified Six Sigma Process Experts</b> driving operational excellence</li>
              <li><b>Industry-leading employee retention rates</b> ensure continuity and experience</li>
              <li><b>Clinical Subject Matter Experts (SMEs)</b> and dedicated account managers aligned to client needs</li>
              <li>A robust network of <b>4,000+ licensed clinicians</b> across multiple specialties</li>
            </ul>
          </div>
          <div className="absence_clinical_outcomes_card">
            <img src={processIcon} alt="Process Icon" className="absence_clinical_outcomes_icon" />
            <div className="absence_clinical_outcomes_card_title">Process</div>
            <ul className="absence_clinical_outcomes_list">
              <li><b>FMLA Pre-Approval</b> workflows to streamline leave requests</li>
              <li>Comprehensive <b>eligibility reviews</b> for all leave types</li>
              <li><b>Client code and intake updates</b> to ensure system accuracy</li>
              <li><b>Verbal certification processing</b> for faster turnaround and compliance</li>
            </ul>
          </div>
          <div className="absence_clinical_outcomes_card">
            <img src={resultsIcon} alt="Results Icon" className="absence_clinical_outcomes_icon" />
            <div className="absence_clinical_outcomes_card_title">Results</div>
            <ul className="absence_clinical_outcomes_list">
              <li><b>Error reduction</b> through standardization and quality control</li>
              <li><b>Citrix license cost savings</b> via efficient resource deployment</li>
              <li><b>Expanded daily coverage</b> and improved case clearance rates</li>
              <li><b>Full utilization of IPA (Intelligent Process Automation)</b> to retain and leverage encoded information</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AbsenceManagement; 